import { render, staticRenderFns } from "./DialogControllerConnections.vue?vue&type=template&id=3b7aa2cf&"
import script from "./DialogControllerConnections.vue?vue&type=script&lang=js&"
export * from "./DialogControllerConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports